import _isEmpty from "lodash/isEmpty";
import i18n from '@signavio/i18n';
import { dataTypeUtils } from '@signavio/effektif-fields';
import * as singleFieldValidators from './validators/single';
import * as listFieldValidators from './validators/lists';
const checkCustomValidator = (field, skipRequiredCheck) => {
  const validator = field.type.name === 'list' ? listFieldValidators[field.type.elementType.name] : singleFieldValidators[field.type.name];
  if (validator) {
    return validator(field, skipRequiredCheck);
  }
  return [];
};
export default function validateField(field, skipRequiredCheck = false) {
  if (field.readOnly || !field.visible) {
    return [];
  }
  let errors = [];
  if (field.required) {
    if (!skipRequiredCheck) {
      if (field.value == null) {
        errors = [...errors, i18n('This field is required')];
      } else if (dataTypeUtils.isList(field.type) && _isEmpty(field.value)) {
        errors = [...errors, i18n('This field is required')];
      }
    }
    errors = [...errors, ...checkCustomValidator(field, skipRequiredCheck)];
  } else if (field.value != null) {
    errors = [...errors, ...checkCustomValidator(field, skipRequiredCheck)];
  }
  return errors;
}